import React, { useState } from "react";

const SportsFilter = ({counts,setActiveFilter, activeFilter}) => {
  const [activeSport, setActiveSport] = useState("all");

  return (
    <div className="w-full">

      {/* ===== Sports Type Filter ===== */}
      {/* <div className="mb-4 flex flex-wrap justify-center gap-2">

        <button
          onClick={() => setActiveSport("all")}
          className={`px-3 py-2 rounded-md text-sm font-semibold transition-all duration-300 ${
            activeSport === "all"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          All Sports
        </button>

        <button
          onClick={() => setActiveSport("cricket")}
          className={`px-3 py-2 rounded-md text-sm font-semibold transition-all ${
            activeSport === "cricket"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          🏏 Cricket
        </button>

        <button
          onClick={() => setActiveSport("football")}
          className={`px-3 py-2 rounded-md text-sm font-semibold transition-all ${
            activeSport === "football"
               ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          ⚽ Football
        </button>

      </div> */}

      {/* ===== Status Filter ===== */}
      <div className="mb-8 flex flex-wrap justify-center gap-2">

        {/* All */}
        <button
          onClick={() => setActiveFilter("all")}
          className={`min-w-[100px] px-3 py-2 rounded-md text-sm font-semibold transition-all ${
            activeFilter === "all"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          All
          <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-white/20">
            {counts.all}
          </span>
        </button>

        {/* Upcoming */}
        <button
          onClick={() => setActiveFilter("upcoming")}
          className={`min-w-[100px] px-3 py-2 rounded-md text-sm font-semibold transition-all flex items-center gap-1 ${
            activeFilter === "upcoming"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          {/* Radio Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="2" />
            <path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9" />
            <path d="M19.1 4.9C23 8.8 23 15.1 19.1 19" />
          </svg>

          Upcoming
          <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-700">
            {counts.upcoming}
          </span>
        </button>

        {/* Live */}
        <button
          onClick={() => setActiveFilter("live")}
          className={`min-w-[100px] px-3 py-2 rounded-md text-sm font-semibold transition-all flex items-center gap-1 ${
            activeFilter === "live"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          {/* Play Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <polygon points="6 3 20 12 6 21 6 3" />
          </svg>

          Live
          <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-700">
            {counts.live}
          </span>
        </button>

        {/* Completed */}
        <button
          onClick={() => setActiveFilter("completed")}
          className={`min-w-[100px] px-3 py-2 rounded-md text-sm font-semibold transition-all flex items-center gap-1 ${
            activeFilter === "completed"
              ? "bg-gradient-to-r from-blue-500 to-pink-500 text-white shadow-lg"
              : "border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          }`}
        >
          {/* Check Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 10A10 10 0 1 1 17 3" />
            <path d="m9 11 3 3L22 4" />
          </svg>

          Completed
          <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-700">
            {counts.completed}
          </span>
        </button>

      </div>

    </div>
  );
};

export default SportsFilter;